import { useCallback } from "react";
import { Pressable } from "react-native";

import { RadioButton } from "./radio-button";
import { TextBody } from "./text";
import { createStyles } from "../theme";

type Props = {
  active: boolean;
  label: string;
  onPress: (value: string | number) => void;
  value: string | number;
};

export function RadioItem({ active, label, onPress, value }: Props) {
  // Handlers
  const handlePress = useCallback(() => {
    onPress(value);
  }, [onPress, value]);

  // Render
  return (
    <Pressable onPress={handlePress} style={$.container}>
      <RadioButton checked={active} />
      <TextBody ml="2">{label}</TextBody>
    </Pressable>
  );
}

const $ = createStyles({
  container: {
    row: 4,
  },
});
